import script from "./AddLotForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddLotForm.vue?vue&type=script&setup=true&lang=js"

import "./AddLotForm.vue?vue&type=style&index=0&id=109e0a96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-109e0a96"]])

export default __exports__